import React, { Component } from 'react';
import { IonInput, IonItem, IonLabel, IonList } from '@ionic/react';
import { IonButton, IonIcon, IonSegment, IonSegmentButton, IonSelect, IonSelectOption } from '@ionic/react';
import { eyeOutline, eyeOffOutline } from 'ionicons/icons';

import AuthResource from '../resources/Auth';
import SystemResource from '../resources/System';
import ErrorLog from '../services/errorlog';
import countryCodes, { DEFAULT_COUNTRY_CODE } from '../utils/countryCodes';

export default class Login extends Component {
  constructor(props) {
    super(props);

    this.form = React.createRef();

    this.state = {
      state: 'login',
      profile: '',
      recoveryMode: 'email',
      recovery_email: '',
      recovery_fiscal_code: '',
      prefix: DEFAULT_COUNTRY_CODE,
      phone_number: '',
    };

    this.countryCodes = countryCodes;

    this.recovery = this.recovery.bind(this);
    this.submit = this.submit.bind(this);
    this.toggleEyeIconStatus = this.toggleEyeIconStatus.bind(this);
  }

  async toggleEyeIconStatus() {
    this.setState({ eyeIconStatus: !this.state.eyeIconStatus });
  }

  /** Identificativo inviato all'API, nella forma attesa dal tipo di campo scelto. */
  recoveryIdentifier() {
    switch (this.state.recoveryMode) {
      case 'phone': {
        const number = `${this.state.phone_number}`.replace(/[^0-9]/g, '');
        return !!number ? `${this.state.prefix}${number}` : '';
      }

      case 'fiscal_code':
        return `${this.state.recovery_fiscal_code}`.trim().toUpperCase();

      default:
        return `${this.state.recovery_email}`.trim();
    }
  }

  async recovery(e) {
    e.preventDefault();

    let email = this.recoveryIdentifier();

    if (!email) {
      if (!!this.props.onRecovery) this.props.onRecovery(new Error('Dato mancante'));
      return;
    }

    try {
      await AuthResource.service.recovery(email);

      if (!!this.props.onRecovery) this.props.onRecovery();
    } catch (error) {
      if (!!this.props.onRecovery) this.props.onRecovery(error);
    }
  }

  async submit(e) {
    e.preventDefault();

    // Invio da tastiera mentre si è nel form di recupero: il campo password non è montato
    if (this.state.state === 'recovery') return await this.recovery(e);

    let [email, password] = [e.target.email.value, e.target.password.value];

    try {
      this.props.loader.current.show();
      let response = await AuthResource.login(email, password);
      if (!!this.props.onSubmit) this.props.onSubmit(null, response);

      /* let {data: {data: profile}} = await ProfileService.me();
      this.setState({ profile }); */
      await SystemResource.privacyCheck();
    } catch (error) {
      this.props.onSubmit(error);
      ErrorLog.send(error);
    } finally {
      if (!!this.props.loader && !!this.props.loader.current) {
        this.props.loader.current.dismiss();
      }
    }
  }

  renderRecoveryFields() {
    const { recoveryMode } = this.state;

    if (recoveryMode === 'phone') {
      return (
        <IonItem>
          <IonLabel position="stacked">Numero di telefono</IonLabel>
          <div style={{ display: 'flex', gap: '8px', width: '100%' }}>
            <IonSelect
              name="prefix"
              value={this.state.prefix}
              onIonChange={(e) => this.setState({ prefix: e.detail.value })}
              interface="action-sheet"
              style={{ maxWidth: '120px' }}
            >
              {this.countryCodes.map((country, index) => (
                <IonSelectOption key={index} value={country.code}>
                  {country.code} {country.country}
                </IonSelectOption>
              ))}
            </IonSelect>
            <IonInput
              type="tel"
              inputmode="tel"
              name="recovery_phone_number"
              placeholder="3201234567"
              value={this.state.phone_number}
              onIonChange={(e) => this.setState({ phone_number: e.detail.value })}
              style={{ flex: 1 }}
            />
          </div>
        </IonItem>
      );
    }

    if (recoveryMode === 'fiscal_code') {
      return (
        <IonItem>
          <IonLabel position="stacked">Codice fiscale</IonLabel>
          <IonInput
            type="text"
            name="recovery_fiscal_code"
            autocapitalize="characters"
            autocorrect="off"
            spellcheck="false"
            maxlength={16}
            placeholder="RSSMRA80A01H501U"
            value={this.state.recovery_fiscal_code}
            onIonChange={(e) => this.setState({ recovery_fiscal_code: e.detail.value })}
          />
        </IonItem>
      );
    }

    return (
      <IonItem>
        <IonLabel position="stacked">Email</IonLabel>
        <IonInput
          type="email"
          inputmode="email"
          name="recovery_email"
          autocapitalize="off"
          autocorrect="off"
          spellcheck="false"
          placeholder="mario.rossi@example.com"
          value={this.state.recovery_email}
          onIonChange={(e) => this.setState({ recovery_email: e.detail.value })}
        />
      </IonItem>
    );
  }

  render() {
    const isRecovery = this.state.state === 'recovery';

    return (
      <form ref={this.form} onSubmit={this.submit}>
        <IonList lines="full" className="ion-no-margin ion-no-padding">
          {isRecovery ? (
            <>
              <IonItem lines="none">
                <IonSegment
                  value={this.state.recoveryMode}
                  onIonChange={(e) => this.setState({ recoveryMode: e.detail.value })}
                >
                  <IonSegmentButton value="email">
                    <IonLabel>Email</IonLabel>
                  </IonSegmentButton>
                  <IonSegmentButton value="phone">
                    <IonLabel>Telefono</IonLabel>
                  </IonSegmentButton>
                  <IonSegmentButton value="fiscal_code">
                    <IonLabel>Cod. fiscale</IonLabel>
                  </IonSegmentButton>
                </IonSegment>
              </IonItem>

              {this.renderRecoveryFields()}
            </>
          ) : (
            <>
              <IonItem>
                <IonLabel position="stacked">
                  Email, codice fiscale o telefono <small>(con prefisso +39)</small>
                </IonLabel>
                <IonInput autocomplete="username" id="email" type="text" name="email" required></IonInput>
              </IonItem>

              <IonItem>
                <IonLabel position="stacked">Password</IonLabel>
                <IonInput
                  autocapitalize="off"
                  autocorrect="off"
                  spellcheck="false"
                  autocomplete="current-password"
                  id="current-password"
                  type={!this.state.eyeIconStatus ? 'password' : 'text'}
                  name="password"
                  required
                />

                <IonIcon
                  className="ion-padding-top"
                  onClick={() => this.toggleEyeIconStatus()}
                  icon={this.state.eyeIconStatus ? eyeOffOutline : eyeOutline}
                  slot="end"
                />
              </IonItem>
            </>
          )}
        </IonList>

        <div className={`ion-padding ${isRecovery ? 'ion-hide' : null}`}>
          <IonButton expand="block" type="submit" className="ion-no-margin">
            Accedi
          </IonButton>
        </div>

        <div className={`ion-padding ${isRecovery ? null : 'ion-hide'}`}>
          <IonButton expand="block" type="button" onClick={this.recovery} className="ion-no-margin">
            Recupera password
          </IonButton>
        </div>

        <div className={`ion-padding ion-text-center ${isRecovery ? 'ion-hide' : null}`}>
          <a
            href="/auth/login"
            onClick={(e) => {
              e.preventDefault();
              this.setState({ state: 'recovery' });
            }}
          >
            Recupera password
          </a>
        </div>

        <div className={`ion-padding ion-text-center ${isRecovery ? null : 'ion-hide'}`}>
          <a
            href="/auth/login"
            onClick={(e) => {
              e.preventDefault();
              this.setState({ state: 'login' });
            }}
          >
            Torna al login
          </a>
        </div>
      </form>
    );
  }
}
